import React from 'react'
import PropTypes from 'prop-types'
import { useValue } from '@morningtrain/react-resources'
import { NotificationCircle } from './'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import ViewSpecialEventsSmartview from 'widgets/smartviews/ViewSpecialEventsSmartview'

export default function CalendarIcon ({
  date,
  scheduleId
}) {
  const name = ['special_events', date].join('.')
  const notifications = useValue(name) || 0

  const wrapperClasses = [
    'relative',
    notifications > 0 ? 'mr-3' : 'mr-2'
  ]

  const iconClasses = [
    'text-primary-900',
    'w-3',
    'h-3',
    notifications > 0 ? 'opacity-100' : 'opacity-50'
  ]

  return (
    <MountSmartviewOnClick smartview={<ViewSpecialEventsSmartview scheduleId={scheduleId} date={date} />} replace={false}>
      <div className={wrapperClasses.join(' ')}>
        <svg
          className={iconClasses.join(' ')} width='15.238' height='16' viewBox='0 0 15.238 16'
          style={{ marginTop: '-0.1rem' }}
        >
          <path
            fill='currentColor'
            d='M13.714,46.857H1.524A1.528,1.528,0,0,1,0,45.333V33.524A1.528,1.528,0,0,1,1.524,32h12.19a1.528,1.528,0,0,1,1.524,1.524V45.333A1.528,1.528,0,0,1,13.714,46.857Zm-12.19-14.1a.764.764,0,0,0-.762.762V45.333a.764.764,0,0,0,.762.762h12.19a.764.764,0,0,0,.762-.762V33.524a.764.764,0,0,0-.762-.762Zm0,0'
            transform='translate(0 -30.857)'
          />
          <path fill='currentColor' d='M320,0h.762V3.048H320Zm0,0' transform='translate(-308.571)' />
          <path fill='currentColor' d='M85.332,0h.762V3.048h-.762Zm0,0' transform='translate(-82.284)' />
          <path
            fill='currentColor' d='M10.668,138.668H25.144v.762H10.668Zm0,0'
            transform='translate(-10.287 -133.716)'
          />
        </svg>
        <NotificationCircle notifications={notifications} hide={notifications === 0} />
      </div>
    </MountSmartviewOnClick>
  )
}

CalendarIcon.propTypes = {
  date: PropTypes.string.isRequired,
  scheduleId: PropTypes.number.isRequired
}
